import React from "react";
import Slider from "./slider";
import { getLocalizedString } from "@icarius-localization/strings";

const orderPolls = (a, b) => {
  if (!a.completed && b.completed) return -1;
  if (a.completed && !b.completed) return 1;
  return 0;
}

const Content = (props) => {

  const {
    counters,
    downloads,
    links,
    news,
    polls,
    handleItemClick,
    handleItemClickPoll,
  } = props;

  const typeItemArr = [
    {
      type: "C",
      items: counters,
      title: getLocalizedString("countersSliderTitle"),
      handleItemClick: handleItemClick,
    },
    {
      type: "M",
      items: news,
      title: getLocalizedString("news"),
      handleItemClick: handleItemClick,
    },
    {
      type: "U",
      items: links,
      title: getLocalizedString("favouriteSliderTitle"),
      handleItemClick: handleItemClick,
    },
    {
      type: "L",
      items: downloads,
      title: getLocalizedString("downloadSliderTitle"),
      handleItemClick: handleItemClick,
    },
    {
      type: "E",
      items: polls.filter((item) => !item.useForOnboarding).sort(orderPolls),
      title: getLocalizedString("pollSliderTitle"),
      handleItemClick: handleItemClickPoll,
    },
  ];

  return (
    typeItemArr.map((typeItem, index) => {
      return (
        <Slider
          key={typeItem.type}
          type={typeItem.type}
          title={typeItem.title}
          items={typeItem.items}
          isLast={typeItemArr.length === (index + 1)}
          handleItemClick={typeItem.handleItemClick}
        />
      )
    })
  )
}

export default Content;